import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithTimeout from './baseQueryWithTimeout';
import { TAG_TYPES } from '../constants/queryTags';

const { VETS } = TAG_TYPES;

export const vetsApi = createApi({
  reducerPath: 'vetsApi',
  baseQuery: baseQueryWithTimeout,
  tagTypes: [VETS],
  endpoints: (builder) => ({
    // GET
    getVets: builder.query({
      query: ({ auth0Token }) => ({
        url: '/api/v3/policy/policyVets',
        headers: { customAuthToken: auth0Token }
      }),
      providesTags: [VETS]
    }),
    getPolicyVetsPerClaim: builder.query({
      query: ({ customerClaimId, auth0Token }) => ({
        url: `/api/v3/policy/policyVetsPerClaim/${customerClaimId}`,
        headers: { customAuthToken: auth0Token }
      }),
      providesTags: [VETS]
    }),
    // POST
    postClaimVetEndorsements: builder.mutation({
      query: (data) => ({
        url: '/api/claim/claimVetEndorsements',
        method: 'POST',
        body: data
      }),
      invalidatesTags: [VETS]
    }),
    postClaimVetDetails: builder.mutation({
      query: (data) => ({
        url: '/api/claim/AddClaimVetDetails',
        method: 'POST',
        body: data
      }),
      invalidatesTags: [VETS]
    }),
    postPolicyVetDetails: builder.mutation({
      query: (data) => ({
        url: '/api/policy/AddPolicyVetDetails',
        method: 'POST',
        body: data
      }),
      invalidatesTags: [VETS]
    })
  })
});

export const {
  useGetVetsQuery,
  useGetPolicyVetsPerClaimQuery,
  usePostClaimVetEndorsementsMutation,
  usePostClaimVetDetailsMutation,
  usePostPolicyVetDetailsMutation
} = vetsApi;
